/**
 * 生命周期 送券弹窗
 */

import React, { Component } from 'react';
import { Flex, Toast } from 'antd-mobile';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';

import { ImgWrap } from 'pubBiz';

require('./AccoumulateLess.less');
import AccoumulateMod from './AccoumulateMod';
import styles from './AccoumulateLess.modules.less';

const CDN_BASE = Config.CDN_BASE || '';
const TypeList = [
  {
    code: -1,
    name: '优惠顾客'
  },
  {
    code: 0,
    name: '普卡'
  },
  {
    code: 1,
    name: '银卡'
  },
  {
    code: 2,
    name: '金卡'
  },
  {
    code: 3,
    name: '钻卡'
  },
  {
    code: 10,
    name: 'VIP'
  }
];

@inject('AppMod')
@inject('ShopHomeMod')
@inject('AccoumulateMod')
@observer
class AccoumulateView extends Component {
  constructor(props, context) {
    super(props, context);
    this.stores = new AccoumulateMod();
    this.state = {};
  }

  componentDidMount() {
    // this.getAccoumulate();
  }

  /**
   * 返回上一页函数
   */
  _onLeftClick = () => {
    window.app.router.goBack();
  };

  /**
   * 展示获取累计制弹框
   */
  getAccoumulate = () => {
    const member_userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
    const { remindTag = 0, cardTypeId } = member_userInfo || {};
    remindTag && this.stores.getCardTypeDetail(cardTypeId);
  };

  showAccoumulateMoal = () => {
    const { userInfo = {} } = this.props.AppMod;
    const { tipContent } = toJS(this.props.ShopHomeMod);
    return (
      <Flex className={styles.modal} justify="center" justifyContent="center" alignItems="center">
        <Flex justify="center" align="center" direction="column" className={styles.container}>
          <ImgWrap src={`${CDN_BASE}/assets/imgs/bg/popup2.png`} mode="full" w="100%" h="100%" />
          <Flex direction="column" className={styles.textInfo}>
            <div className={styles.title}>恭喜</div>
            <div className={styles.text}>
              {`${'恭喜您荣升成为'}`}
              <span className={styles.highLight}>{`${userInfo.cardTypeName}，`}</span>
              {!!tipContent.sendNum && `特赠送您`}
              {!!tipContent.sendNum && (
                <span className={styles.highLight}>{tipContent.sendNum}</span>
              )}
              {!!tipContent.sendNum && `张优惠券，`}
              {`快点击下方`}
              {!!tipContent.sendNum && `获取权益去使用吧~`}
              <p>
                如有疑问，可联系您的健康顾问或致电您专属的服务热线4008225588转1，我们将秉承“自尊敬人，惠人达已”的核心价值观竭诚为您服务~
              </p>
            </div>
          </Flex>
          {this.bothShow(userInfo)}
          <div
            className={styles.close}
            onClick={() => {
              const { tipContent = {} } = this.props.ShopHomeMod;
              this.stores.submitCouponUpdate(tipContent.memberUpgradeRecordId);
              this.props.callback && this.props.callback(false);
            }}>
            <img src={`${CDN_BASE}/assets/imgs/common/close_2.png`} />
          </div>
        </Flex>
      </Flex>
    );
  };

  // 根据不同 的情况展示不同的按钮
  bothShow = (member_userInfo) => {
    const { cardType, cardCode, systemType, lifecycleTag, lifecycleMaxCardType } = member_userInfo;
    return (
      <Flex justify="center" alignItems="center" className={styles.btnContainer}>
        {/* 以前最高级别为 cardType 3 古语最高级别为钻3 cardType 6 */}
        {(cardType === 3 && systemType == '0') ||
        (systemType == '1' && cardType === lifecycleMaxCardType && !!lifecycleTag)
          ? !!lifecycleTag &&
            systemType == '1' && (
              <Flex
                className={styles.btn}
                justify="center"
                align="center"
                justifyContent="center"
                onClick={() => {
                  window.app.routerGoTo({
                    pathname: '/learn/PromotionTree/PromotionTreeView',
                    search: Util.encodeQuery({
                      thematicId: '1346356125848752228'
                    })
                  });
                }}>
                {'学习地图'}
              </Flex>
            )
          : this.props.shouldSupplyTag == 1 && (
              <Flex
                className={styles.btn}
                justify="center"
                align="center"
                justifyContent="center"
                onClick={() => {
                  window.app.routerGoTo({
                    pathname: '/personal/msgAdd',
                    state: {
                      data: {
                        accumulate: 3,
                        localCardCode: cardCode
                      }
                    }
                  });
                }}>
                {'完善资料'}
              </Flex>
            )}

        <Flex
          className={styles.btn}
          justify="center"
          align="center"
          onClick={() => {
            window.app.routerGoTo('/promote/equity');
          }}>
          {'查看权益'}
        </Flex>
      </Flex>
    );
  };

  // 完善资料处理
  checkSupplementInfo = (value) => {
    //preferentialCustomersTag 是否从优惠顾客上来的，0-不是  1-是
    const { cardCode, preferentialCustomersTag } = value || {};
    if (+value === 2 || value == 'upgrate') {
      this.stores.submitTapUpdate(value === 2 ? 2 : 0).then((res) => {
        if (res && +res.resultCode === 0) {
          value === 2 && this.props.callback && this.props.callback(true, res.data);
          if (value == 'upgrate') {
            this.props.callback && this.props.callback(false);
            Toast.info(`升级成功！`);
          }
        }
      });
      return;
    }
    if (!preferentialCustomersTag) {
      this.props.callback && this.props.callback(false);
      window.app.routerGoTo({
        pathname: '/register/memCardMsg',
        clear: true,
        state: {
          applyType: '3',
          accumulate: 1,
          supplementInfo: true
        }
      });
    } else if (preferentialCustomersTag) {
      this.props.callback && this.props.callback(false);
      const pathname = '/personal/msgAdd';
      window.app.routerGoTo({
        pathname,
        clear: true,
        state: {
          applyType: 3,
          data: {
            localCardCode: cardCode,
            accumulate: 1,
            remindTag: 1
          }
        }
      });
    } else {
    }
  };

  render() {
    return <React.Fragment>{this.showAccoumulateMoal()}</React.Fragment>;
  }
}

export default AccoumulateView;



// WEBPACK FOOTER //
// ./src/widget/AccoumulateV2/AccoumulateView.js